import React, {RefObject} from 'react'
import {Link, Prompt} from 'react-router-dom'
import ContentTypesService from "model/service/dataStorage/ContentTypesService"
import {
    Badge,
    Breadcrumb,
    Button,
    Card, Col, Divider,
    FormInstance,
    Menu,
    message, Modal, Row,
    Select,
    Skeleton,
    Spin,
    Tooltip,
    Typography
} from 'antd';
import {
    AppstoreAddOutlined,
    BarChartOutlined,
    BuildOutlined,
    CodeOutlined,
    ControlOutlined,
    EyeOutlined,
    HomeOutlined,
    InfoCircleOutlined,
    KeyOutlined,
    MessageOutlined,
    ProfileOutlined,
    RollbackOutlined,
    SaveOutlined,
    SearchOutlined,
    SettingOutlined,
    ShareAltOutlined,
    ThunderboltOutlined,
    UnorderedListOutlined
} from "@ant-design/icons";
import IContentType from "../../../../model/interface/dataStorage/IContentType";
import IExtensionType from "../../../../model/interface/dataStorage/IExtensionType";
import ContentTypeProperties from "./ContentTypeProperties";
import ContentTypeFields from "./ContentTypeFields";
import ContentTypeActions from "./ContentTypeActions";
import ContentTypePresenters from "./ContentTypePresenters";
import ContentTypePermissions from "./ContentTypePermissions";
import ContentTypeScripts from "./ContentTypeScripts";
import IBaseProps from "../../../../model/interface/IBaseProps";
import ErrorReport from "../../error/ErrorReport";
import {connect, RootStateOrAny} from "react-redux";
import {ISetupState} from "../../../../redux/reducers/Setup";
import IFieldType from "../../../../model/interface/dataStorage/IFieldType";
import type {MenuInfo} from 'rc-menu/es/interface';
import IExtension from "../../../../model/interface/dataStorage/IExtension";
import _ from "underscore"
import IField from "../../../../model/interface/dataStorage/IField";
import Utils from "../../../../utils";
import ContentTypeCards from "./ContentTypeCards";
import ContentTypeForms from "./ContentTypeForms";
import {reLoad} from "../../../../redux/actions/Setup";
import IForm from "../../../../model/interface/form/IForm";
import ICardWidget from "../../../../model/interface/dataStorage/card/ICardWidget";
import IRestServiceOptions from "../../../../model/interface/api/IRestServiceOptions";
import IScreen from "../../../../model/interface/ui/IScreen";
import ContentTypeRoutes from "./ContentTypeRoutes";
import IContentTypeRoute from "../../../../model/interface/dataStorage/IContentTypeRoute";
import IWidget from "../../../../model/interface/form/IWidget";
import ContentTypeMaintenance from "./ContentTypeMaintenace";
import ContentTypeNotifications from "./ContentTypeNotifications";
import FormFieldType from "../form/FormElement/formField/FormFieldType";
import FieldEditor from "../form/FormElement/optionEditor/FieldEditor";
import ContentTypeViews from "./ContentTypeViews";
import ContentTypeStatistics from "./ContentTypeStatistics";
import IView from "../../../../model/interface/dataStorage/IView";
import ICard from "../../../../model/interface/dataStorage/ICard";
import ContentTypeConfiguration from "./ContentTypeConfiguration";
import IAction from "../../../../model/interface/dataStorage/IAction";
import selectors from "../../../../redux/selectors";
import IRepositoryService from "../../../../model/interface/IRepositoryService";
import ICompositeFieldType from "../../../../model/interface/dataStorage/field/ICompositeFieldType";
import settingsService from "../../../../model/service/SettingsService";
import LocaleText from "../../settings/dictionary/LocaleText";
import ScrollContainer from "../../../shared/scrollContainer/ScrollContainer";
export interface IContentTypeStepProps extends IBaseProps {
    resource: IContentType,
    extensionTypes: IExtensionType[],
    onValuesChange: (values: { [x: string]: any }) => void,
    fieldScalarTypes: IFieldType[],
    compositeFieldTypes: ICompositeFieldType[]
    relationTypes: { value: string, label: string }[],
    contentTypes: IContentType[]
    onStepChange: (step: string) => void
    forms: IForm[]
}

interface IProps extends IBaseProps {
    contentTypes: IContentType[],
    fieldTypes: IFieldType[],
    compositeFieldTypes: ICompositeFieldType[]
    extensionTypes: IExtensionType[],
    forms: IForm[],
    masterClasses: string[],
    reLoad: () => void,
    loaded: boolean
    resource?: IContentType,
    standAlone?: boolean,
    preview?: boolean
    views: IView[]
    findServiceByClassName: (name: string) => IRepositoryService | null
    onCollisionEnd?: (resource: IContentType) => void
    getText: (code: string, fallback?: string) => string
}

interface IState {
    resource: IContentType,
    step: string,
    shouldBlockNavigation: boolean,
    loading: boolean,
    extensionTypes: IExtensionType[],
    fieldScalarTypes: { value: string, label: string }[],
    relationTypes: { value: string, label: string }[],
    contentTypes: IContentType[],
    propertiesFormRef: RefObject<FormInstance>
    screen: IScreen
    forms: IForm[]
    screenTimeout: null | NodeJS.Timeout,
    updateCollision?: IContentType
}

class ContentType extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        const resourceUuid = Utils.uuid()
        this.state = {
            resource: {
                id: 0,
                uuid: resourceUuid,
                name: '',
                label: '',
                description: '',
                fullClassName: '',
                collection: '',
                revisionHistory: true,
                actions: [
                    {
                        uuid: Utils.uuid(),
                        name: 'show',
                        type: 'show',
                        label: 'Zobrazit',
                        form: null,
                        forms: [],
                        locked: true,
                        contentType: resourceUuid,
                        notifications: [],
                        actionScripts: []
                    }
                ],
                fields: [],
                presenters: [],
                notifications: [],
                extensions: [],
                rules: [],
                masterClass: '',
                cards: [],
                forms: [],
                routes: [],
                readAction: null,
                parent: null,
                scripts: [],
                views: []
            } as IContentType,
            step: 'basic',
            shouldBlockNavigation: false,
            loading: true,
            forms: this.props.forms,
            extensionTypes: [],
            fieldScalarTypes: [],
            relationTypes: [],
            contentTypes: [],
            propertiesFormRef: React.createRef() as RefObject<FormInstance>,
            screen: Utils.getScreenInfo(),
            screenTimeout: null
        }
    }

    componentDidMount() {
        const {resource} = this.props
        if (resource) {
            return this.setResource(resource)
        }
        this.load()
    }

    componentDidUpdate = () => {
        if (this.state.shouldBlockNavigation) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = null
        }
    }

    load() {
        const {match} = this.props
        Promise.all([
            'contentTypeId' in match.params && match.params['contentTypeId'] ? ContentTypesService.resourceRetrieve(
                parseInt(match.params['contentTypeId'], 10)
            ).then(resource => {
                ContentTypesService.getFieldRelationTypes().then(relationTypes => {
                    this.setState({
                        relationTypes
                    })
                })
                this.setResource(resource)
            }) : this.setState({loading: false}),

        ])

        Utils.registerScreenUpdate(
            (screenTimeout: NodeJS.Timeout) => this.setState({screenTimeout}),
            (screen: IScreen) => this.setState({screen}),
        )
    }

    setResource(resource: IContentType) {
        const {forms} = this.props
        this.setState({
            resource: this.getResource(resource, forms),
            loading: false
        }, this.state.propertiesFormRef.current?.resetFields)
    }

    getResource(resource: IContentType, forms: IForm[]) {
        return {
            ...resource,
            forms: typeof resource.forms[0] === 'string' ? forms
                .filter(f => f.uuid && (resource.forms as unknown as string[] /*TODO ?*/).includes(f.uuid)) : resource.forms
        };
    }

    handleClick = ({key}: MenuInfo) => {
        this.setState({
            step: key as string
        })
    }

    handleChangeGroup(step: string) {
        this.setState({step})
    }

    onValuesChange = (values: { [x: string]: string }) => {
        let resource = {
            ...this.state.resource,
            ...values
        }
        if (typeof values['extensions'] !== 'undefined') {
            resource = this.checkExtensionFields(resource)
        }

        this.setState(_state => ({
            resource
        }))
        this.forceUpdate()
    }

    checkExtensionFields = (resource: IContentType) => {
        resource.extensions.forEach((extension: IExtension) => {
            const extensionType = _.findWhere(this.props.extensionTypes, {type: extension.type})
            if (!extensionType) {
                throw new Error('Invalid extension type: ' + extension.type)
            }
            extensionType.fields.forEach((extensionField) => {
                const {name} = extensionField
                const index = Utils.findIndex(resource.fields, {name})
                const resourceField: IField = resource.fields[index]
                if (resourceField) {
                    resource.fields[index].locked = true
                } else {
                    const field: IField = {
                        ...extensionField,
                        locked: true
                    }
                    resource.fields.push(field)
                }
            })
        })
        return resource
    }

    onSave = (stay: boolean) => {
        this.state.propertiesFormRef.current?.validateFields()
            .then(() => stay ? this.saveAndStay() : this.saveAndBack())
            .catch((e) => {
                console.log(e)
                this.setState({step: 'basic'})
            })
    }

    save(): Promise<IContentType | void> {
        const {resource, updateCollision} = this.state
        const {reLoad, getText} = this.props
        const id = this.state.resource.id
        const data = {
            ...resource,
            updatedAt: updateCollision?.updatedAt || resource.updatedAt,
            masterClass: resource.masterClass ?? null,
            actions: resource.actions.map(action => ContentTypeConfiguration.mapAction(action)),
            fields: resource.fields.map(field => ({
                ...field,
                label: field.label ? field.label : null,
                contentTypeName: field.contentTypeName || false,
                script: field.script || null,
                loadInCollection: !!field.loadInCollection,
                loadInResource: !!field.loadInResource,
                defaultValue: FormFieldType.formatFromForm(FieldEditor.detectType(field), field.defaultValue) || null,
                deleteRelated: !!field.deleteRelated
            })),
            presenters: resource.presenters,
            extensions: resource.extensions.map(extension => ({
                id: extension.id,
                type: extension.type
            })),
            rules: resource.rules.length > 0 ? resource.rules.map((rule, index) => ({
                ...rule,
                conditions: rule.conditions ? rule.conditions.map(condition => ({
                    ...condition,
                    field: condition.field || null,
                    inheritRule: condition.inheritRule || null,
                })) : null,
                ruleConnections: rule.ruleConnections, // TODO ?
                weight: index + 1
            })) : null,
            cards: ContentTypeConfiguration.prepareCards(resource.cards),
            forms: ContentTypeConfiguration.prepareForms(resource.forms),
            notifications: resource.notifications || [],
            routes: resource.routes.length > 0 ? resource.routes : resource._createBasicRoutes
            && resource._basicRouteName ? this.buildBasicRoutes(resource._basicRouteName) : [],
            scripts: resource.scripts || []
        }
        this.setState({
            loading: true,
            updateCollision: undefined
        })
        const options: IRestServiceOptions = {depth: 2}
        const promise = id ? ContentTypesService.resourceUpdate(id, data, options) : ContentTypesService.collectionCreate(data, options)
        return promise.then(contentType => {
            message.success(
                `Typ obsahu [${getText(contentType.label || '')}] byl úspěšně uložen.`
            ).then()
            reLoad()
            return contentType
        }).catch(error => {
            if (error.status === 409) {
                console.log(error)
                this.setState({updateCollision: error.data.resource})
            }
            ErrorReport.create("Při ukládání typu obsahu vznikla chyba", error, data)
            this.setState({loading: false})
        })
    }

    static prepareForms(forms: IForm[] = []): IForm[] {
        return forms.length > 0 ? forms.map(form => ({
            id: form.id ? form.id : undefined,
            name: form.name,
            label: form.label,
            priority: form.priority,
            contentType: form.contentType,
            conditions: form.conditions,
            defaultValues: form.defaultValues,
            widgets: form.widgets.map((widget: IWidget) => {
                const item = {...widget} as any
                delete item.children
                return item
            })
        })) : []
    }

    static mapAction(action: IAction) {
        return {
            ...action,
            label: action.label || '',
            forms: action.forms ? action.forms : null,
            actionScripts: action.actionScripts ? action.actionScripts.map(actionScript => {
                const script = {
                    ...actionScript,
                    script: actionScript.script || null,
                }
                delete script.action
                return script
            }) : null,
            confirmModalEnabled: action.confirmModalEnabled || false,
            noContextReload: action.noContextReload || false,
            modal: action.modal || false
        };
    }

    buildBasicRoutes(routePath: string): IContentTypeRoute[] | unknown {
        return [
            {name: 'list', route: {url: '/app/' + routePath}},
            {name: 'show', route: {url: '/app/' + routePath + '/:identifier'}},
            {name: 'edit', route: {url: '/app/' + routePath + '/:identifier/upravit'}},
            {name: 'create', route: {url: '/app/' + routePath + '/vytvorit'}}
        ]
    }

    static prepareCards = (cards: ICard[] = []) => {
        return cards.length > 0 ? cards.map(card => ({
            id: card.id ? card.id : null,
            name: card.name,
            label: card.label,
            route: card.route,
            widgets: card.widgets.map((widget: ICardWidget) => {
                const item = {...widget} as any
                delete item.children
                return item
            }),
            routePriority: card.routePriority,
            action: card.action,
            conditions: card.conditions
        })) : []
    }

    saveAndStay() {
        this.save().then(contentType => {
            if (!contentType) {
                return
            }
            this.props.history.push('/app/configuration/content-types/' + contentType.id)
        })
    }

    saveAndBack() {
        this.save().then(contentType => {
            if (!contentType) {
                // error was thrown
                return
            }
            this.props.history.go(-1)
        })
    }

    onStepChange = (step: string) => {
        this.setState({step})
    }

    buildGroups() {
        return [
            {
                "name": "basic",
                "icon": (<InfoCircleOutlined/>),
                "title": "Základní informace"
            },
            {
                "name": "fields",
                "icon": (<UnorderedListOutlined/>),
                "title": "Pole a vazby",
                "count": this.state.resource.fields.length
            },
            {
                "name": "forms",
                "icon": (<ProfileOutlined/>),
                "title": "Formuláře",
                "count": this.state.resource.forms.length
            },
            {
                "name": "actions",
                "icon": (<ThunderboltOutlined/>),
                "title": "Akce",
                "count": this.state.resource.actions.length
            },
            {
                "name": "presenters",
                "icon": (<SearchOutlined/>),
                "title": "Zobrazení",
                "count": this.state.resource.presenters.length
            },
            {
                "name": "cards",
                "icon": (<AppstoreAddOutlined/>),
                "title": "Karty",
                "count": this.state.resource.cards.length
            },
            {
                "name": "permissions",
                "icon": (<KeyOutlined/>),
                "title": "Práva",
                "count": this.state.resource.rules.length
            },
            {
                name: 'routes',
                icon: <ShareAltOutlined/>,
                title: 'URL cesty',
                "count": this.state.resource.routes.length
            },
            {
                name: 'notifications',
                icon: <MessageOutlined/>,
                title: 'Upozornění',
                "count": this.state.resource.notifications.length
            },
            {
                name: 'views',
                icon: <EyeOutlined/>,
                title: 'Pohledy',
                "count": this.listViews().length
            },
            {
                name: 'scripts',
                icon: <CodeOutlined/>,
                title: 'Scripty',
                "count": this.state.resource.scripts.length
            }
        ]
    }


    protected listViews(): IView[] {
        if (!this.state.resource) {
            return []
        }
        return this.props.views
            .filter(view => {
                return view.contentTypes.indexOf(this.state.resource!.uuid) >= 0
            })
            .sort((a, b) => {
                return a.label > b.label ? 1 : -1
            })
    }

    render() {
        const {
            step,
            resource,
            shouldBlockNavigation,
            loading,
            relationTypes,
            propertiesFormRef,
            forms,
            screen,
            updateCollision
        } = this.state
        const {
            contentTypes,
            fieldTypes,
            compositeFieldTypes,
            extensionTypes,
            masterClasses,
            history,
            match,
            standAlone,
            preview,
            loaded,
            findServiceByClassName,
            onCollisionEnd,
            reLoad
        } = this.props
        const stepProps = {
            forms,
            onValuesChange: this.onValuesChange,
            extensionTypes: extensionTypes,
            resource: {
                ...resource,
                fields: resource.fields.filter(f => !f.targetEntity || findServiceByClassName(f.targetEntity))
            },
            fieldScalarTypes: fieldTypes,
            compositeFieldTypes,
            relationTypes,
            contentTypes,
            history,
            match,
            onStepChange: this.onStepChange
        }

        const content = (
            <>
                <div>
                    {standAlone ? '' : <Breadcrumb className={"mb-3"}>
                        <Breadcrumb.Item href={"/app"}>
                            <HomeOutlined/>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={"/app/configuration"}>
                                <SettingOutlined className={'mr-2'}/>
                                <span><LocaleText code={'configuration'} fallback={'Konfigurace'}/></span>
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {loading ? (
                                <Spin spinning={true}/>
                            ) : (
                                <>
                                    <BuildOutlined/>
                                    <span>{resource.id ? resource.name : 'Nový typ obsahu'}</span>
                                </>
                            )}
                        </Breadcrumb.Item>
                    </Breadcrumb>}
                </div>
                <div className={screen.isMobile ? "" : "inner-app-layout"}>
                    {screen.isMobile ? (
                        <Select
                            className={"w-100 mb-4"}
                            defaultValue={"basic"}
                            onChange={(value: string) => this.handleChangeGroup(value)}
                            options={this.buildGroups().map(group => ({
                                value: group.name,
                                label: (<>{group.icon} {group.title}</>)
                            }))}
                        />
                    ) : (
                        <div className={"side-content d-block"}>
                            <Menu
                                onClick={this.handleClick}
                                mode="vertical"
                                defaultSelectedKeys={['basic']}
                            >
                                <Menu.ItemGroup key="g1" title="Konfigurace">
                                    {this.buildGroups().map((group, index) => (
                                        <Menu.Item key={group.name} active={index === 0}>
                                            {group.icon}
                                            {group.count === undefined
                                                ? (<span>{group.title}</span>)
                                                : (<span>{group.title}
                                                    <Badge count={group.count}
                                                           className={"float-right"} style={{
                                                        transform: 'translateY(45%)',
                                                        verticalAlign: 'middle',
                                                        background: 'inherit',
                                                        color: 'inherit',
                                                        boxShadow: '0 0 0 1px #d9d9d9 inset'
                                                    }} showZero={true}/></span>)
                                            }

                                        </Menu.Item>
                                    ))}
                                </Menu.ItemGroup>
                                {!preview && (
                                    <Menu.ItemGroup key="g2" title="Údržba">
                                        <Menu.Item key={"maintenance"}>
                                            <ControlOutlined/>
                                            <span>Správa</span>
                                        </Menu.Item>
                                        <Menu.Item key={"statistics"}>
                                            <BarChartOutlined/>
                                            <span>Statistiky</span>
                                        </Menu.Item>
                                    </Menu.ItemGroup>
                                )}
                            </Menu>
                            {!preview && (
                                <Button.Group>
                                    <Button className={"mt-3"} type={"primary"} icon={<SaveOutlined/>}
                                            onClick={() => onCollisionEnd ? onCollisionEnd(resource) : this.onSave(true)}>
                                        Uložit
                                    </Button>
                                    {!onCollisionEnd && <Tooltip title={'Uložit a odejít'}>
                                        <Button className={"mt-3"} type={"primary"} icon={<RollbackOutlined/>}
                                                onClick={() => this.onSave(false)}/>
                                    </Tooltip>}
                                </Button.Group>
                            )}
                        </div>
                    )}

                    <div className={"main-content flex-grow-1 gutter"} style={{minWidth: 0}}>
                        <ContentTypeProperties
                            {...stepProps}
                            formRef={propertiesFormRef}
                            hidden={step !== 'basic'}
                            masterClasses={masterClasses}
                        />
                        {(
                            {
                                'fields': <ContentTypeFields {...stepProps} resource={resource}/>,
                                'actions': <ContentTypeActions {...stepProps} />,
                                'presenters': <ContentTypePresenters {...stepProps} />,
                                'cards': <ContentTypeCards {...stepProps} />,
                                'forms': <ContentTypeForms {...stepProps} />,
                                'permissions': <ContentTypePermissions {...stepProps} />,
                                'scripts': <ContentTypeScripts {...stepProps} />,
                                'routes': <ContentTypeRoutes {...stepProps} />,
                                'notifications': <ContentTypeNotifications {...stepProps} />,
                                'views': <ContentTypeViews views={this.listViews()} {...stepProps} />,
                                'maintenance': <ContentTypeMaintenance setupLoaded={loaded}
                                                                       setupReLoad={reLoad} {...stepProps}/>,
                                'statistics': <ContentTypeStatistics {...stepProps}/>,
                            }[step]
                        )}
                    </div>

                    {screen.isMobile && !preview && (
                        <div className={"mt-3"}>
                            <Button.Group>
                                <Button className={"mt-3"} type={"primary"} icon={<SaveOutlined/>}
                                        onClick={() => onCollisionEnd ? onCollisionEnd(resource) : this.onSave(true)}>
                                    Uložit
                                </Button>
                                {!onCollisionEnd && <Tooltip title={'Uložit a odejít'}>
                                    <Button className={"mt-3"} type={"primary"} icon={<RollbackOutlined/>}
                                            onClick={() => this.onSave(false)}/>
                                </Tooltip>}
                            </Button.Group>
                        </div>
                    )}
                </div>
            </>
        )

        return <>{standAlone ? (loading ? <Spin spinning={true}/> : content) : (
            <>
                <Prompt
                    when={shouldBlockNavigation}
                    message='You have unsaved changes, are you sure you want to leave?'
                />
                {loading ? (
                    <Skeleton.Button className={'mb-2'} active={true} style={{width: 200}} size={"small"}/>
                ) : (
                    <Typography.Title level={1} style={{color: settingsService.getThemeColor(), marginBottom: 10}}>
                        {<LocaleText code={resource?.label || ''} fallback={resource?.label}/> || 'Nový typ obsahu'}
                    </Typography.Title>
                )}
                <Card loading={loading}>
                    {content}
                </Card>
            </>
        )}
            {updateCollision ? <Modal width={'95vw'} visible={true} footer={false} closable={false}>
                <Typography.Title level={2} className={'text-center'}>
                    <LocaleText code={'configuration.collision'} fallback={'Kolize změn'}/>
                </Typography.Title>
                <Row justify={"center"} className={'mb-2'}>
                    <Typography.Text type={'secondary'}>
                        <LocaleText code={'configuration.collision.help'}
                                    fallback={'Najděte rozdíly nebo kontaktujte osobu, která provedla poslední změnu, upravte a uložte požadovanou verzi.'}/>
                    </Typography.Text>
                </Row>
                <Row wrap={false}>
                    <Col flex={'1'} style={{width: 0}}>
                        <Typography.Title level={3} className={'text-center'}>
                            <LocaleText code={'configuration.collision.yours'} fallback={'Vaše změny'}/>
                        </Typography.Title>
                        <ScrollContainer style={{maxHeight: '60vh'}}>
                            <ContentTypeConfiguration standAlone={true} resource={resource} match={match}
                                                      history={history}
                                                      onCollisionEnd={r => this.setState({resource: r}, () => this.onSave(true))}/>
                        </ScrollContainer>
                    </Col>
                    <Col>
                        <Divider className={'h-100'} type={'vertical'}/>
                    </Col>
                    <Col flex={'1'} style={{width: 0}}>
                        <Typography.Title level={3} className={'text-center'}>
                            {updateCollision.updatedBy ? updateCollision.updatedBy.username :
                                <LocaleText code={'configuration.collision.theirs'} fallback={'Jejich změny'}/>}
                        </Typography.Title>

                        <ScrollContainer style={{maxHeight: '60vh'}}>
                            <ContentTypeConfiguration standAlone={true} resource={updateCollision} match={match}
                                                      history={history}
                                                      onCollisionEnd={r => this.setState({resource: r}, () => this.onSave(true))}/>
                        </ScrollContainer>
                    </Col>
                </Row>
            </Modal> : ''}
        </>
    }
}

const mapStateToProps = (state: RootStateOrAny) => {
    const {
        loaded,
        contentTypes,
        fieldTypes,
        extensionTypes,
        masterClasses,
        forms,
        views,
        compositeFieldTypes
    } = state.setup as ISetupState

    return {
        loaded,
        contentTypes,
        fieldTypes,
        compositeFieldTypes,
        extensionTypes,
        masterClasses,
        forms,
        views,
        findServiceByClassName: (name: string) => selectors.services.findOneOrNullByFullClassName(state, name),
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback),
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        reLoad: () => dispatch(reLoad())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentType)

